<div [@routerTransition]>
    <section class="container p-5">
        <h1 class="mb-10 title">Termos de Uso</h1>
        <div class="mb-10 text" [innerHTML]="termsOfUse | sanitizeHtml"></div>
    </section>
</div>
